module.exports = __webpack_public_path__ + "static/media/water.2d590323.png";